import http, { API_PREFIX } from './http'
import type { 
  LoginRequest, 
  TokenResponse, 
  UserInfo, 
  AuthConfig, 
  SetupRequest, 
  SetupResponse, 
  RegisterRequest, 
  RegisterResponse, 
  EmailVerificationRequest, 
  ResendVerificationRequest, 
  EmailVerificationResponse,
  SetPasswordRequest,
  ChangePasswordRequest,
  PasswordResponse,
  AuthStatusResponse,
  LinkingInitiationRequest,
  LinkingInitiationResponse,
  LinkingCompletionRequest,
  LinkingCompletionResponse,
  UnlinkExternalRequest,
  UnlinkExternalResponse
} from '@/models/Auth'

export const authApi = {
  login: (data: LoginRequest) => http.post<TokenResponse>(`${API_PREFIX}/auth/login`, data),
  getCurrentUser: () => http.get<UserInfo>(`${API_PREFIX}/auth/me`),
  getAuthConfig: () => http.get<AuthConfig>(`${API_PREFIX}/auth/config`),
  completeSetup: (data: SetupRequest) => http.post<SetupResponse>(`${API_PREFIX}/auth/setup`, data),
  register: (data: RegisterRequest) => http.post<RegisterResponse>(`${API_PREFIX}/auth/register`, data),
  verifyEmail: (token: string, signature: string) => http.post<EmailVerificationResponse>(`${API_PREFIX}/auth/verify-email/${token}`, { signature }),
  verifyEmailCode: (verificationCode: string) => http.post<EmailVerificationResponse>(`${API_PREFIX}/auth/verify-email-code`, { verification_code: verificationCode }),
  resendVerification: (data: ResendVerificationRequest) => http.post<EmailVerificationResponse>(`${API_PREFIX}/auth/resend-verification`, data),
  getVerificationStatus: (userId: string) => http.get<EmailVerificationResponse>(`${API_PREFIX}/auth/verification-status/${userId}`),
  
  // Enhanced Authentication Endpoints
  setPassword: (data: SetPasswordRequest) => http.post<PasswordResponse>(`${API_PREFIX}/auth/set-password`, data),
  changePassword: (data: ChangePasswordRequest) => http.post<PasswordResponse>(`${API_PREFIX}/auth/change-password`, data),
  getAuthStatus: () => http.get<AuthStatusResponse>(`${API_PREFIX}/auth/auth-status`),
  
  // Account Linking Endpoints
  linkKeycloak: (data: LinkingInitiationRequest) => http.post<LinkingInitiationResponse>(`${API_PREFIX}/auth/link-keycloak`, data),
  confirmLinkKeycloak: (data: LinkingCompletionRequest) => http.post<LinkingCompletionResponse>(`${API_PREFIX}/auth/confirm-link-keycloak`, data),
  unlinkExternalIdentity: (data: UnlinkExternalRequest) => http.delete<UnlinkExternalResponse>(`${API_PREFIX}/auth/unlink-external`, { data }),
}